// extracted by mini-css-extract-plugin
module.exports = {"layout":"AppLayout_layout__21cR_","japan":"AppLayout_japan__3j554","showMe":"AppLayout_showMe__36pGQ"};